import { FeatureIslandMainWithCategoryWrapper } from "@/components/features/_layouts";

import { QuestionOptionPlanConnection } from "./plan-connection/plan-connection";
import { QuestionOptionSaleTypeForPlan } from "./sale-type-for-plan";

import type { StandardOptionCategoriesAndManagerStore } from "../../store/categories";

type Props = {
	planRestrictionsAndConnection: StandardOptionCategoriesAndManagerStore["planRestrictionsAndConnection"];
};

export const QuestionOptionPlanRestrictionsAndConnection = ({ planRestrictionsAndConnection }: Props) => {
	return (
		<>
			<FeatureIslandMainWithCategoryWrapper
				islandTitle="プラン紐付け"
				categoryStore={planRestrictionsAndConnection}
			>
				<QuestionOptionPlanConnection />
			</FeatureIslandMainWithCategoryWrapper>

			<FeatureIslandMainWithCategoryWrapper
				islandTitle="プラン限定販売"
				categoryStore={planRestrictionsAndConnection}
			>
				<QuestionOptionSaleTypeForPlan />
			</FeatureIslandMainWithCategoryWrapper>
		</>
	);
};

QuestionOptionPlanRestrictionsAndConnection.displayName = "QuestionOptionPlanRestrictionsAndConnection";
